import { Euro, Clock, TrendingUp, Layers } from "lucide-react";
import { fmtEur } from "../lib/api";

const Stat = ({ icon: Icon, label, value, sub, tone, testId, delay }) => (
  <div style={{ animationDelay: `${delay}ms` }}
    className={`rise rounded-2xl border p-5 ${tone}`}>
    <div className="flex items-center justify-between">
      <span className="text-[11px] font-bold uppercase tracking-wider text-muted-foreground">{label}</span>
      <Icon className="h-4 w-4 opacity-70" />
    </div>
    <div data-testid={testId} className="mt-3 font-num text-3xl font-bold tracking-tight sm:text-4xl">{value}</div>
    {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
  </div>
);

export const StatCards = ({ totals, settings }) => (
  <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
    <div className="col-span-2 lg:col-span-1">
      <Stat icon={Euro} label="Est. gross salary" value={fmtEur(totals.gross_salary)} testId="stat-gross-salary" delay={0}
        sub={`at ${fmtEur(settings.hourly_rate)}/h · before tax`}
        tone="border-amber-500/40 bg-gradient-to-br from-amber-500/15 via-amber-500/5 to-transparent text-amber-50" />
    </div>
    <Stat icon={Clock} label="Hours worked" value={`${totals.paid_hours}h`} testId="stat-hours-worked" delay={60}
      sub={`${totals.break_hours}h breaks`} tone="border-border/70 bg-card" />
    <Stat icon={TrendingUp} label="Overtime" value={`${totals.overtime_hours}h`} testId="stat-overtime-hours" delay={120}
      sub={`paid at ${settings.ot_rate_pct}%`} tone="border-emerald-500/30 bg-gradient-to-br from-emerald-500/10 to-transparent" />
    <Stat icon={Layers} label="Shifts" value={totals.shift_count} testId="stat-shift-count" delay={180}
      sub={`${totals.days_worked} days worked`} tone="border-indigo-500/30 bg-gradient-to-br from-indigo-500/10 to-transparent" />
  </div>
);
